<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    title="合格投资者确认"
    :show-close="false"
    :center="true"
    :before-close="handleClose"
    class="investor-wrapper"
  >
    <div class="operate">
      <div class="item information">{{ pageInfo.title }}</div>
      <div class="investor-title">若您/贵机构有意向购买私募基金产品：</div>
      <div class="item desc">{{ pageInfo.investor }}</div>
      <div class="investor-title">若您/贵机构有意向购买资产管理产品：</div>
      <div class="item desc">{{ pageInfo.organization }}</div>
      <div class="tips">如果您/贵机构符合以上标准，需点击下方“确认为合格投资者”，方可继续观看本内容。<br/>
如果您/贵机构不符合以上标准，请点击下方“放弃”，您将退出观看本内容。</div>
    </div>
    <template slot="footer">
      <el-button class="btn" @click.stop="handleClose">放弃</el-button>
      <el-button class="btn certain" @click.stop="confirm">确认为合格投资者</el-button>
    </template>
  </el-dialog>
</template>
<script>
import { getLcWeb } from '@/api/lc_web'
export default {
  props: {
    detail: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pageInfo: {
        title:
          '为了更好地保障您的权益，根据《关于规范金融机构资产管理业务的指导意见》《私募投资基金监督管理暂行办法》等相关规定，本内容仅面向合格投资者。合格投资者应具备相应风险识别能力和风险承担能力，且为符合下列标准的个人和机构。',
        investor:
          '个人金融资产不低于300万元或者近三年个人年均收入不低于50万元人民币；机构净资产不低于1000万元。',
        organization: '个人具有两年以上投资经历，且满足以下条件之一，即家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或者近三年本人年均收入不低于40万元；机构最近一年末净资产不低于1000万元。'
      },
      dialogVisible: false
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    async confirm () {
      if (!this.$store.state.user.token) {
        return
      }
      const obj = {
        name: 'lc.app.live.customerFirmInsert',
        data: {
          customerNo: this.$store.state.user.uid,
          liveId: this.detail.id
        }
      }
      const res = await getLcWeb(obj)
      if (res.code === 0) {
        this.$emit('investorConfrim')
      } else {
        this.$showError(res.msg)
      }
    }
  }
}
</script>
<style scoped>
.investor-wrapper ::v-deep .el-dialog__header{
  border-bottom:1px solid #eee;
}
.investor-wrapper ::v-deep .el-dialog__body{
  padding-top:14px;
  font-size:14px;
  padding-bottom:0;
}
.operate>.item,.tips{
 line-height:20px;
}
.btn{
  min-width: 76px;
  padding:6px 5px;
  border-radius: 4px;
}
.certain {
  margin-left:24px;
  background: #187fc3;
  color: #fff;
}
.investor-title {
  font-weight: 700;
  margin:20px 0 10px 0;
}
.desc {
  color: #969696;
}
.tips{
    margin-top:20px;
}
.investor-wrapper ::v-deep .el-dialog__footer{
  padding-top:20px;
}
</style>
